/**
 * Shared chart configuration for audit reports
 */

import type { ChartConfig } from '@/components/ui/chart';

export const auditChartConfig = {
  CREATE: {
    label: 'Create',
    color: 'hsl(var(--chart-1))',
  },
  UPDATE: {
    label: 'Update',
    color: 'hsl(var(--chart-2))',
  },
  DELETE: {
    label: 'Delete',
    color: 'hsl(var(--chart-3))',
  },
  VERSION: {
    label: 'Version',
    color: 'hsl(var(--chart-4))',
  },
  total: {
    label: 'Total',
    color: 'hsl(var(--chart-5))',
  },
} satisfies ChartConfig;

export const entityTypeChartConfig = {
  AttributeDefinition: {
    label: 'Attributes',
    color: 'hsl(var(--chart-1))',
  },
  PolicyDraft: {
    label: 'Policies',
    color: 'hsl(var(--chart-2))',
  },
  AttributeHierarchy: {
    label: 'Hierarchies',
    color: 'hsl(var(--chart-3))',
  },
  Conversation: {
    label: 'Conversations',
    color: 'hsl(var(--chart-4))',
  },
  DatabaseTable: {
    label: 'Database Tables',
    color: 'hsl(var(--chart-5))',
  },
} satisfies ChartConfig;
